
jQuery(document).ready(
  function(){
    
    jQuery('a.scrollink').click(
      function(){
      	var href = jQuery(this).attr('href');
        scrollink(href);
      }
   	);
    
    jQuery('.swatch').find('label').click(
      function(){
        showBigImageFromSwatch(jQuery(this));
      }
    );


    jQuery('.remove-cart-item').click(
      function(e){
        e.preventDefault();
        var variant_id = jQuery(this).attr('data-variant-id');
        var $li = jQuery(this).parent();
        removeFromCart(variant_id,
          function(r){

            updateCart(r);

            $li.slideUp()
          }
        );
        return false;

      }
    );
    
  }
);





function updateCart(cart){

  var t = cart.total_price;
  var c = cart.item_count;

  t = Math.floor(t);
  t = t/100;

  var u = '$ '+t+' USD';

  jQuery('.mm-counter').text(u);
  jQuery('.cart_count').text(c);

}

function removeFromCart(variant_id, callback){

  Shopify.changeItem(
    variant_id,
    0,
    function(r){
      callback(r);
    }
    );

}



// Functions that scrolls to a certain point
function scrollink(target){
  
	target = target.replace('#' ,''); 
  
	jQuery('html, body').animate(
		{
    		scrollTop: jQuery(".scrollink-"+target).offset().top
  		},
		2000
	);
  
}
